import { AutoComplete, Tooltip, Input } from 'antd';
import styled from 'styled-components';
import {
  WrapLabel
} from "../../../ContributionType/styles";

const { Option } = AutoComplete;
const Search = Input.Search;
export const WrapperToolTip = styled(Tooltip)`
  z-index: 9999 !important;
`;

export const AutoSearch = styled(AutoComplete)`
.ant-select-selection__placeholder{
  z-index:4;
  cursor: text;
}
  width: 300px;
  height: 40px;
  && input {
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    font-size: ${props => props.theme.fontSize.primary};
    line-height: ${props => props.theme.lineHeight.tertiaryUpdated};
    color: ${props => props.theme.fontColors.textColor};
    border: solid 1px #d4d4d4;
    border-radius: 0;
    padding-left: 20px;
    text-overflow: ellipsis;

    &::placeholder {
      color: ${props => props.theme.fontColors.placeholder};
    }

    @media only screen and (max-width: 576px) {
      font-size: ${props => props.theme.fontSize.secondary} !important;
    }
  }

  .has-error .ant-input.ant-select-search__field {
    border-color: ${props => props.theme.colors.lightGrey};
    color: ${props => props.theme.colors.lightGrey};
    border-bottom: 1px solid #505050 !important;
  }

  .has-error .ant-input:not([disabled]):hover {
    border-bottom: 1px solid #505050 !important;
  }

  .ant-form-item-control {
    line-height: unset !important;
  }
  // .ant-input:hover {
  //   border: 1px solid #505050 !important;
  // }

  // .ant-input:focus {
  //   border: none !important;
  // }

  .ant-input{
  &:hover, &:focus{
    border: 1px solid #505050 !important;
    box-shadow: none !important;
    }
  }

  .ant-select-selection__placeholder {
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    font-size: ${(props) => props.theme.fontSize.primary};
    padding-left: 8px;
  }
  .ant-select-selection--single,
  & .ant-input {
    height: 40px !important;
  }   

  .ant-select-dropdown {
    border-top: none;
    border-radius: 0;
    li {
    background-color: #ffffff;
    padding: 5px 20px;
    }
    li:hover {
    color: #167f91;
    background-color: #e6f7ff;
    }
    }
    @media only screen and (min-width: 768px) and (max-width: 1200px) {
      &&.assetHeldOutside .ant-select-selection__placeholder {
        text-overflow: ellipsis !important;
        width: 55% !important;
      }
    }
    @media only screen and (max-width: 576px) {
      .ant-select-selection__placeholder {
        font-size: ${(props) => props.theme.fontSize.secondary};
      }
    }
    && .assetOutsideSearchInput {
      z-index: 4 !important;
    }
    && .assetOutsideSearchInput .ant-input-search-button {
      margin-top: 1px;
      height: 36px;
      color: ${props => props.theme.colors.dropdownArrow};
      border: 1px solid ${props => props.theme.border.pill};
      border-bottom: 0px;
      border-top: 0px;
      border-right: 0px;
      background: linear-gradient(180deg, #FFFFFF 0%, #F2F2F2 100%);
    }
    && .assetOutsideSearchInput .ant-input-group-addon {
      background: none;
    }
    && .assetOutsideSearchInput .ant-input: hover {
      background-color: transparent !important;
    }
`;


export const OptionsWrapper = styled.div`
  padding: 8px;
  justify-content: space-between;
  @media only screen and (max-width: 768px) {
    height: auto;
    display: block;
    overflow: unset !important;
  }
`;

export const OptionText = styled.div`
  font-size: ${(props) => props.theme.fontSize.primary};
`;

export const OptionDesc = styled.div`
  white-space: normal;
  font-size: ${(props) => props.theme.fontSize.primary};
  @media only screen and (max-width: 768px) {  
    white-space: normal;
    width: auto;
    overflow: unset;
    text-overflow: unset;
    text-align: unset
  }
`;

export const SearchInput = styled(Search)`
   height: 40px;
   & input{
     font-family: ${props => props.theme.fontFamily.helveticaNeue};
     font-size: ${props => props.theme.fontSize.primary};
     border: 1px solid ${props => props.theme.border.pill} !important;
     border-radius: 0;
   }
 
   & input::placeholder {
     font-family: ${props => props.theme.fontFamily.helveticaNeue};
     color: ${props => props.theme.fontColors.placeholder};
     font-size: ${props => props.theme.fontSize.primary}; 
     @media (max-width: 991px) {
       font-size: ${props => props.theme.fontSize.tertiary};
     }
   } 
   & input::-moz-placeholder { /* Mozilla Firefox 4 to 18 */
     line-height: 50px !important;
   }
   .ant-input-suffix svg{
     width: 23px;
     height: 23px;
     color : #167f91;
     @media (max-width: 991px) {
       width:20px;
       height:20px;
     }
   }
 
   .ant-input-suffix {
    right: 10px !important;
   }
  
`;
export const AssetOutsideWrapLabel = styled(WrapLabel)`
  && .ant-select-selection {
    border: 1px solid #d4d4d4 !important;
    border-radius: 0px !important;
  }
  && .ant-select-selection:hover {
    border: 1px solid #505050 !important;
  }
  && .ant-select-auto-complete.ant-select .ant-input {
    border: none !important;
  }
  && .ant-select-auto-complete.ant-select .ant-input:focus,
  && .ant-select-auto-complete.ant-select .ant-input:hover {
    border: none !important;
  }
  && .has-error .ant-select-selection.ant-select-selection--single {
    display: inline-table !important;
    width: 100% !important;
  }
  && .has-error .ant-select-auto-complete.ant-select .ant-input {
    border-bottom: none !important;
  }
  && .has-error .auto_complete .ant-input:not([disabled]):focus {
    border-bottom: none !important;
  }
  && .ant-select-selection__placeholder, && .ant-select-search__field__placeholder {
    font-size: ${(props) => props.theme.fontSize.primary} !important;
  }
  @media only screen and (max-width: 770px) {
    && .ant-select-selection__placeholder, .ant-select-search__field__placeholder {
      font-size: ${(props) => props.theme.fontSize.secondary} !important;
    }
  }
`;

